import React from "react";
import "./LoadingSpinner.css";

const LoadingSpinner = () => {
  return (
    <div className="LoadingSpinner lds-ellipsis">
      <div/>
      <div/>
      <div/>
      <div/>
    </div>
  );
};

export default LoadingSpinner;
